module.exports = __webpack_public_path__ + "img/up_arrow.e6643074.svg";